import { fetch, Method } from 'core/api/fetch';

const previewCache = new Map();
const pendingRequests = new Map();

export const PreviewService = {
    getPreview: async ({ entity, id, queryParams = {} }) => {
        const cacheKey = `${entity}:${id}`;

        // Return cached data immediately
        if (previewCache.has(cacheKey)) {
            return { data: previewCache.get(cacheKey) };
        }

        // Wait for pending request if one exists
        if (pendingRequests.has(cacheKey)) {
            return pendingRequests.get(cacheKey);
        }

        // Create new request
        const requestPromise = (async () => {
            try {
                const queryString = Object.keys(queryParams).length > 0 ? `?${new URLSearchParams(queryParams).toString()}` : '';

                const url = `/api/v1.1.1/host/preview/${entity}/${id}${queryString}`;

                const response = await fetch(url, {
                    method: Method.GET,
                    authenticated: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                // Cache the result
                previewCache.set(cacheKey, response.data);
                pendingRequests.delete(cacheKey);

                return response;
            } catch (error) {
                pendingRequests.delete(cacheKey);
                console.error(`Error fetching preview for ${entity} with ID ${id}:`, error);
                throw error;
            }
        })();

        pendingRequests.set(cacheKey, requestPromise);
        return requestPromise;
    },

    // Add cache management
    clearCache: () => {
        previewCache.clear();
    },
};
